<template>
  <el-row>
    <!-- 顶头信息 -->
    <el-row>
      <div class="top1" style="background-color: #FFF; border-bottom: solid 1px #E5E5E5;">
        <div class="top_1">
          <div class="top_1_1">
            <a class="changehands" @click="showWechatImg()" style="cursor:pointer;" >关注微信</a>
          </div>
          <div class="top_1_2">
            <ul id="sddm">
              <li style="float: right;"><a href="#">客服电话：029-68892595</a></li>
              <li style="float: right;"><a href="http://gsvweb.zft365.com/#/">管理登录</a></li>
            </ul>
          </div>
        </div>
      </div>
    </el-row>
    <el-row style="width:70%; margin:0 auto;">
      <!-- 登录区 -->
      <el-row v-show="loginFormVisible">
        <div class="top2">
          <div class="top2_1">
            <div class="logo">
              <table>
              <tr>
                <td>
                  <img :src="sylogo" width="200px;" height="50px"/>
                </td>
                <td style="border-right:1px solid #CCC;">
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </td>
                <td>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </td>
                <td>
                  <img :src="UnionPayOnlinePayment" width="150" height="37"/>
                </td>
              </tr>
              </table>
              <a href="javascript:();"></a>
            </div>
            <div class="nav">
              <ul style="float: right;">
                <li><a href="http://www.xasyu.cn/">学院首页</a></li>
                <li><a href="http://www.xasyu.cn/web/?path=xyjs&typeid=xyjs">走进思源</a></li>
              </ul>
            </div>
          </div>
        </div>
        <!-- header is over -->
        <div class="content main">
          <div class="jf">
            <div class="dlck" style="float: left;">
              <h3 class="h3">
                    西安思源学院
              </h3>
              <div>
              </div>
              <el-row style="margin-top: 14px">
                <el-form :model="global.curUser" ref="form" label-width="60px">
                  <el-form-item label="注册号">
                    <el-input v-model="global.curUser.keyInfo" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                  <el-form-item label="姓名">
                    <el-input v-model="global.curUser.userName" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                </el-form>
                
                <el-row style="width:100%;margin: 20px auto;"><el-button style="width: 100%" type="success" @click="query()">登录</el-button></el-row>
              </el-row>
            </div>
            <div style="width: 545px; height: 380px; float: right;">
              <!-- <div id="idContainer2" class="container" style="margin:8px 8px 0px 0px; background: #000; width: 590px; height: 370px;border:1px solid #CCC;" > -->
                <el-carousel indicator-position="outside">
                  <el-carousel-item>
                    <img :src="siyuan1" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="siyuan2" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="siyuan3" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="siyuan4" />
                  </el-carousel-item>
                </el-carousel>
            </div>
          </div>
          
        </div>
        <br/>
        <div class="tybottom">
          <div class="hzhb">
            <table width="100%;" border="0" cellpadding="0" cellspacing="0">
            <tr style="line-height: 5px;">
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td width="250px;" valign="top">
                <h2>合作伙伴</h2>
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td valign="top">
                <h2>支持银行（200余家）</h2>
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td>
                &nbsp;
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td>
                &nbsp;
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <img :src="coopLogo" width="187" height="50" style="margin-bottom: 0px;" />
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                <el-row>
                  <el-col :span="1" v-for="item in imgListBank" :key="item.id">
                    <div>
                      <el-button type="text" @click="handleButtonCommand(item.redirectUrl)">
                        <img :src="item.url"/>
                      </el-button>
                    </div>
                  </el-col>
                </el-row>
              </td>
            </tr>
            <tr style="line-height: 8px;">
              <td>
                &nbsp;
              </td>
              <td style="border-right:1px solid #CCC;">
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
            </table>
          </div>
          <div class="Copy">
              技术提供方　西安银杏软件有限公司　陕ICP备14001946号-2
            <br/>客服电话：4008786390
          </div>
        </div>
        <div id="loadimg" align="center" style="width:100%; height:100%; left:0px; top:0px; right:0px; bottom:0px; display:none; position:fixed; background-color:rgba(0,0,0,0.5); z-index:999999;">
            <div style="width:300px;height:330px;margin-top:100px;background: #FFF"  align="center">
              <div style="width: 100%;height: 10px;">
                <span onclick="closewximg()" style="font-size: 20px; font-weight:500; color: #000; cursor: pointer; float: right;color: red;">×&nbsp;&nbsp;</span>
                </div>
                <br/>
              <div align="center">
                    <img :src="qrcode" width="250px;" height="250px;"/><br/><br/>
              </div>
            </div>
        </div>
      </el-row>
      <!-- 标签 --> 
      <el-row v-show="menuVisible">
        <el-menu
          default-active="/MyBill"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item index="/MyBill">我的账单</el-menu-item>
          <el-menu-item index="/MyBillHistory">已缴账单</el-menu-item>
        </el-menu>
        <br>
        <br>
      </el-row>
      <!-- 宿舍信息 -->
      <el-row v-show="dormListVisible">
        <el-table ref="dorm" :data="dormList" highlight-current-row stripe border>
          <!-- 操作列 -->
          <el-table-column label="分类名称" min-width="100" fixed header-align="center">
            <template slot-scope="scope">
              <el-radio style="font-size: 12px;" v-model="selectedRadio" :label="scope.row.分类名称"></el-radio>
            </template>
          </el-table-column>
          <!-- <el-table-column label="宿舍" prop="ITEM">
          </el-table-column> -->
          <el-table-column label="分类序号" prop="分类序号" header-align="center" min-width="90">
          </el-table-column>
          <el-table-column label="宿舍" prop="ITEM" header-align="right" min-width="90">
          </el-table-column>
          <el-table-column label="金额" prop="分类标准" :formatter="dataFormat" align="right" min-width="90">
          </el-table-column>
          <el-table-column label="说明" prop="宿舍说明" header-align="center" min-width="400">
          </el-table-column>
        </el-table>
        <el-row style="text-align:center;padding:10px 0">
          <el-button style="width:20%" type="danger" @click="chooseDorm()" :loading="buttonLoad">确定</el-button>
        </el-row>
      </el-row>
      <!-- 账单信息 -->
      <el-row v-show="feeListVisible" style="background-color: #fff;">
        <el-row v-show="photoVisible" style="background-color: #fff; text-align: center;">
          <img style="margin-top: 12px;border-radius: 8px;" :src="photo" width="90" height="120">
        </el-row>
        <el-row>
          <el-form :model="viewForm" ref="viewForm" label-width="100px" label-position="left" style="width: 50%;background-color: #fff;margin:auto">
            <el-form-item label="注册号" class="form-item">
              <span>{{ viewForm.注册号 }}</span>
            </el-form-item>
            <el-form-item label="姓名" class="form-item">
              <span>{{ viewForm.姓名 }}</span>
            </el-form-item>
            <el-form-item label="性别"  class="form-item">
              <span>{{ viewForm.性别 }}</span>
            </el-form-item>
            <el-form-item label="年级" class="form-item">
              <span>{{ viewForm.年级 }}</span>
            </el-form-item>
            <el-form-item label="班级"  class="form-item">
              <span>{{ viewForm.班级 }}</span>
            </el-form-item>
            <el-form-item label="总额"  class="form-item" v-if="getFeeDetailVisible()">
              <span>{{ Ginkgo.format(viewForm.总额, 'money') }}</span>
            </el-form-item>
            <el-form-item label="总额"  class="form-item" v-if="!getFeeDetailVisible()">
              <span>不欠费</span>
            </el-form-item>
            <el-form-item label="实缴" class="form-item" v-if="getFeeDetailVisible()">
              <el-input v-model="form.feeAmount" placeholder="请输入"></el-input>
            </el-form-item>
            <el-collapse v-if="getFeeDetailVisible()">
              <el-collapse-item title="费用明细" name="1" style="width: 100%">
                <el-row>
                  <!-- <div ><span class="label_detail">保险费</span><span class="label_value">100.00</span></div> -->
                  <div v-for="item in feeData" :key="item.ITEM">
                    <span class="label_detail">{{ item.ITEM }}</span><span class="label_value">{{ Ginkgo.format(item.AMOUNT, 'money') }}</span>
                  </div>
                </el-row>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </el-row>
        <el-row style="text-align:center;padding:10px 0" v-if="getFeeDetailVisible()">
          <el-button style="width:20%" type="primary" @click="toPay()" :disabled="payButtonDisable" v-if="feePayType_UN">银联支付</el-button>
        </el-row>
      </el-row>
      <!-- 历史查询结果窗体 -->
      <el-row v-show="feeListHistoryVisible">
        <el-table ref="resultTable" :data="tableData"
          style="width: 100%; margin-top: 10px;" @sort-change="handleSortChangeHistory" highlight-current-row stripe border :height="global.tableHeight"
        >
          <el-table-column type="index" fixed width="60">
          </el-table-column>
          <!-- 数据列 -->
          <el-table-column
            v-for="item in getUISetQueryResult('01')" :key="item.columnName" :prop="item.columnProp" :label="item.columnDesc.split('|')[0]"
              :min-width="item.colWidth" :align="item.alignType" :formatter="dataFormatHistory"
              :fixed="Ginkgo.getColumnFixed(item)" sortable="custom" header-align="center"
            v-if="getHeaderVisible(item, 1)"
          >
            <el-table-column
              v-for="item2 in getHeaderGroup(item, 2, '01')" :key="item2.columnName" :prop="item2.columnProp" :label="item2.columnDesc.split('|')[1]"
                :min-width="item2.colWidth" :align="item2.alignType" :formatter="dataFormatHistory"
                :fixed="Ginkgo.getColumnFixed(item2)" sortable="custom" header-align="center"
              v-if="getHeaderVisible(item2, 2)"
            >
              <el-table-column
                v-for="item3 in getHeaderGroup(item2, 3, '01')" :key="item3.columnName" :prop="item3.columnProp" :label="item3.columnDesc.split('|')[2]"
                  :min-width="item3.colWidth" :align="item3.alignType" :formatter="dataFormatHistory"
                  :fixed="Ginkgo.getColumnFixed(item3)" sortable="custom" header-align="center"
                v-if="getHeaderVisible(item3, 3)"
              >
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: center;" @size-change="handleSizeChangeHistory" @current-change="handleCurrentChangeHistory"
          :current-page="page.number + 1" :page-sizes="page.pageSizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalElements" :page-count="page.totalPages"
        >
        </el-pagination>
      </el-row>
      <!-- 关注微信 -->
      <el-row>
        <el-dialog :title="dialogFormTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
          <el-row style="text-align:center;padding:10px 0">
            <img :src="weixin" />
          </el-row>
        </el-dialog>
      </el-row>
     </el-row> 
  </el-row>
</template>
<script>
export default {
  name: 'MyBillSiYuan', // ?
  data: function () {
    return {
      weixin: this.global.staticResourceAddr + 'gsvvuepcoif/images/zft2Code.jpg',
      sylogo: this.global.staticResourceAddr + 'gsvvuepcoif/images/siyuan/sylogo.png',
      UnionPayOnlinePayment: this.global.staticResourceAddr + 'gsvvuepcoif/images/siyuan/UnionPayOnlinePayment.png',
      siyuan1: this.global.staticResourceAddr + 'gsvvuepcoif/images/siyuan/1.jpg',
      siyuan2: this.global.staticResourceAddr + 'gsvvuepcoif/images/siyuan/2.jpg',
      siyuan3: this.global.staticResourceAddr + 'gsvvuepcoif/images/siyuan/3.jpg',
      siyuan4: this.global.staticResourceAddr + 'gsvvuepcoif/images/siyuan/4.jpg',
      coopLogo: this.global.staticResourceAddr + 'gsvvuepcoif/images/bank/coopLogo.png',
      qrcode: this.global.staticResourceAddr + 'gsvvuepcoif/images/siyuan/qrcode_for_gh_638bf326c0ab_430.jpg',
      profile: 'prod',
      modeSelectList: [],
      feeList: [],
      feeData: [],
      payTypeUnion: '01',
      payRule: '',
      pageStyle: '01',
      detailViewTypeKd: '',
      multipleSelection: [],

      form: {},
      viewForm: {},
      photo: '',
      responseObj: {}, // 接口返回来的对象
      dormList: [], // 宿舍列表
      dormMoney: '', // 学生选择的宿舍收费标准

      // 控制参数
      loginFormVisible: true,
      feeListVisible: false,
      feeListHistoryVisible: false,
      dormListVisible: false,
      dialogFormVisible: false,
      tabSelected: 'default',
      payButtonDisable: false,
      menuVisible: false,
      selectedRadio: '',
      statusCodeFee: '',
      photoVisible: false, // 照片属性

      tableData: [],  // table绑定数据
      termList: [],
      buttonLoad: false,
      feePayType_UN: true,
      payRules: false,
      // 查询窗体
      queryForm: {},
      uiSetItemList: [], // 原始
      uiSetList: [],
      uiSetForCross: [], // 交叉表最终结果设置
      payTypeList: [],
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),
      // ！！！初始排序对象
      sort: {},
      sortSet: [],
      dormDesc: [
        { 分类名称: '新C类', 宿舍说明: '六人间，上铺下桌带书架，独立衣柜，带室内卫生间。' },
        { 分类名称: '新B类', 宿舍说明: '六人间，两个下铺四个上铺，独立书桌书架，室内带空调、暖气，安装防盗门，公共卫生间，楼层淋浴。' },
        { 分类名称: '新B+类', 宿舍说明: '六人间，上铺下桌带书架，独立衣柜，室内带空调、暖气、独立卫生间，室内洗浴，安装防盗门。' },
        { 分类名称: '新A类', 宿舍说明: '六人间，上铺下桌带书架，独立衣柜，室内带空调、暖气，独立卫生间，室内洗浴，安装防盗门。' }
      ],
      imgListBank: [
        { id: 1, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh001.jpg', redirectUrl: '' },
        { id: 2, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh002.jpg', redirectUrl: '' },
        { id: 3, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh003.jpg', redirectUrl: '' },
        { id: 4, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh004.jpg', redirectUrl: '' },
        { id: 5, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh005.jpg', redirectUrl: '' },
        { id: 6, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh006.jpg', redirectUrl: '' },
        { id: 7, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh007.jpg', redirectUrl: '' },
        { id: 8, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh008.jpg', redirectUrl: '' },
        { id: 9, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh009.jpg', redirectUrl: '' },
        { id: 10, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh010.jpg', redirectUrl: '' },
        { id: 11, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh011.jpg', redirectUrl: '' },
        { id: 12, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh012.jpg', redirectUrl: '' },
        { id: 13, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh013.jpg', redirectUrl: '' },
        { id: 14, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh014.jpg', redirectUrl: '' },
        { id: 15, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh015.jpg', redirectUrl: '' },
        { id: 16, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh016.jpg', redirectUrl: '' },
        { id: 17, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh017.jpg', redirectUrl: '' },
        { id: 18, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh018.jpg', redirectUrl: '' },
        { id: 19, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh019.jpg', redirectUrl: '' },
        { id: 20, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh020.jpg', redirectUrl: '' },
        { id: 21, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh021.jpg', redirectUrl: '' },
        { id: 22, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh022.jpg', redirectUrl: '' },
        { id: 23, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh023.jpg', redirectUrl: '' },
        { id: 24, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh024.jpg', redirectUrl: '' },
        { id: 25, url: this.global.staticResourceAddr + 'gsvvuepcoif/images' + '/bank/yh025.jpg', redirectUrl: '' }
      ]
    }
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') {
      // self.$indicator.open()
      this.getMode()
      this.getUISet()
      this.initQueryForm()
    } else {
      this.feeList = [
        {term: '1', feeAmount01: 1001, feeAmount02: 501, feeAmount03: 5011, feeNo: '01', feeType: '01'},
        {term: '2', feeAmount01: 1002, feeAmount02: 502, feeAmount03: 5022, feeNo: '01', feeType: '01'}
      ]
      this.crossItemList = [
        {feeNo: '01', deptId: 1000001, feeName: '学费', feeType: '01', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '01'},
        {feeNo: '02', deptId: 1000001, feeName: '伙食费', feeType: '02', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '02'},
        {feeNo: '03', deptId: 1000001, feeName: '住宿费', feeType: '02', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '03'}
      ]
      // 界面配置表
      this.uiSetList = [
        {uiSetId: 'tbPm_Fee_Kd_07', uiSetName: '费用信息管理', uiSetType: '01', uiSetTypeDesc: '', colWidthOpt: '300', exportTextSet: '', crossItemNo: 'feeNo', crossItemName: 'feeName', mergeCell: '', remark: '', itemList: null}
      ]
      // 界面配置子表
      this.uiSetItemList = [
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount01', columnDesc: '主费用', columnProp: 'feeAmount01', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '0', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount02', columnDesc: '伙食费', columnProp: 'feeAmount02', isVisible: '0', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount03', columnDesc: '取暖费', columnProp: 'feeAmount03', isVisible: '0', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'Term', columnDesc: '账期', columnProp: 'term', isVisible: '1', isVisibleDesc: '', sortNo: '03', queryCondition: '1', queryConditionDesc: '', sortNoQuery: '03', controlType: '01', controlTypeDesc: '', typeId: '', defaultValue: '', required: '1', requiredDesc: '', isUnique: '1', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''}
      ]
      this.setVisible('01')
    }
  },
  watch: {
  },
  methods: {
    setVisible: function (showType) {
      console.log('进来啦。。。。。', showType)
      if (showType === '01') { // 登录显示
        this.loginFormVisible = true
        this.feeListVisible = false
        this.dormListVisible = false
        this.menuVisible = false
        this.feeListHistoryVisible = false
      }
      if (showType === '02') { // 宿舍显示
        this.loginFormVisible = false
        this.feeListVisible = false
        this.dormListVisible = true
        this.feeListHistoryVisible = false
        this.menuVisible = true
      }
      if (showType === '03') { // 费用信息
        this.loginFormVisible = false
        this.feeListVisible = true
        this.dormListVisible = false
        this.feeListHistoryVisible = false
        this.menuVisible = true
      }
      if (showType === '04') { // 缴费历史
        this.loginFormVisible = false
        this.feeListVisible = false
        this.dormListVisible = false
        this.feeListHistoryVisible = true
        this.menuVisible = true
      }
    },
    getFeeDetailVisible: function () {
      let visible = true
      visible = visible && !(this.statusCodeFee === '不欠费')
      return visible
    },
    // 多选响应
    handleSelectionChange: function(val) {
      this.multipleSelection = val
    },
    // 初始化数据字典
    getMode: function () {
      var self = this
      self.modeSelectList = self.global.modeList
    },
    // 加载界面配置
    getUISet: function () {
      var self = this
      self.uiSetItemList = self.global.uiSetItemList
      self.uiSetList = self.global.uiSetList
    },
    // 初始化查询条件窗体
    initQueryForm: function () {
      this.form = this.Ginkgo.resetForm(this.uiSetItemList, 'tbIf_Order_Info_MyBillSiYuan')
      // 初始化排序
      this.sortSet = this.Ginkgo.getDefaultSort(this.getUISetCommon('01'))
      this.sort = this.sortSet[this.sortSet.length - 1]
    },
    // 获取待缴费账单（核准状态）
    query: function () {
      if (process.env.NODE_ENV === 'production') {
        if (this.global.curUser.keyInfo === '' || this.global.curUser.userName === '') {
          this.$alert('注册号或者姓名不能为空！')
        } else {
          this.login()
        }
      } else {
        this.dormList = [
          {ITEM: '111', 分类标准: '3000', 分类序号: '123', 分类名称: 'kkk', isExpanded: 0},
          {ITEM: '2222', 分类标准: '3000', 分类序号: '123', 分类名称: 'kkk', isExpanded: 0},
          {ITEM: '3333', 分类标准: '3000', 分类序号: '123', 分类名称: 'kkk', isExpanded: 0}
        ]
        this.setVisible('02')
      }
    },
    getPhoto: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        // 组织查询参数
        let request = {}
        request.idIf = 10
        request.deptId = this.global.deptId
        request.itemList = [
          {idIf: 10, paramName: 'id', paramValue: this.global.curUser.keyInfo}
        ]
        this.axios.post('/iif/accessIfForHttp', request
        )
        .then(function (response) {
          console.log('getPhoto response', response.data)
          if (response.data.result.success === true) {
            let obj = response.data.responseObj
            if (obj.data.trim() === '') {
              self.photoVisible = false
              self.photo = ''
            } else {
              self.photoVisible = true
              self.photo = 'data:image/jpeg;base64,' + obj.data
            }
          } else {
            self.$alert(response.data.result.msg)
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.setVisible('03')
      }
    },
    login: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        // 初始化
        self.selectedRadio = ''
        // 组织查询参数
        let request = {}
        request.idIf = 1
        request.deptId = this.global.deptId
        request.itemList = [
          {idIf: 1, paramName: 'id', paramValue: this.global.curUser.keyInfo},
          {idIf: 1, paramName: 'vxm', paramValue: this.global.curUser.userName}
        ]
        this.axios.post('/iif/accessIfForHttp', request
        )
        .then(function (response) {
          console.log('login response', response.data)
          if (response.data.result.success === true) {
            let obj = response.data.responseObj
            if (obj.状态) {
              if (obj.状态 === '已有住宿费标准' || obj.状态 === '已有缴费记录') {
                self.queryInfo('-1')
              } else {
                self.$alert(obj.状态)
              }
            } else {
              self.dormList = response.data.responseObj.住宿类别
              // 为dormList增加展开标识
              self.dormList.forEach(function (ele) {
                let dorm = self.dormDesc.filter(element => element.分类名称 === ele.分类名称)
                if (dorm.length > 0) {
                  ele.宿舍说明 = dorm[0].宿舍说明
                } else {
                  ele.宿舍说明 = ''
                }
                ele.isExpanded = 0
              })
              // 只有一种宿舍直接跳过选择界面
              if (self.dormList.length === 1) {
                let obj = self.dormList[0]
                self.dormMoney = obj.分类标准
                self.queryInfo(obj.分类序号)
              } else {
                self.setVisible('02')
              }
              self.buttonLoad = false
            }
          } else {
            self.buttonLoad = false
            self.$alert(response.data.result.msg)
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.setVisible('03')
      }
    },
    queryInfo: function (vssfl) {
      var self = this
      // 组织查询参数
      let request = {}
      request.idIf = 2
      request.deptId = this.global.deptId
      request.itemList = [
        {idIf: 2, paramName: 'id', paramValue: this.global.curUser.keyInfo},
        {idIf: 2, paramName: 'vxm', paramValue: this.global.curUser.userName},
        {idIf: 2, paramName: 'vssfl', paramValue: vssfl}
      ]
      console.log('queryInfo request', request)
      this.axios.post('/iif/accessIfForHttp', request
      )
      .then(function (response) {
        console.log('query response', response.data)
        if (response.data.result.success === true) {
          self.responseObj = response.data.responseObj
          self.viewForm = {
            注册号: self.responseObj.注册号,
            姓名: self.responseObj.姓名,
            性别: self.responseObj.性别,
            年级: self.responseObj.年级,
            班级: self.responseObj.班级,
            总额: 0
          }
          // 获取照片信息
          // self.getPhoto()
          self.statusCodeFee = self.responseObj.状态 // 隐藏东西
          if (self.responseObj.状态 !== '欠费') {
            if (self.responseObj.状态 === '不欠费') {
              self.$alert(self.responseObj.状态 + ',' + self.responseObj.说明)
              self.setVisible('03')
              // self.getPhoto()
            } else if (self.responseObj.状态 === '异常') {
              self.$alert(self.responseObj.状态 + ',' + self.responseObj.说明 + ';请去财务处现场处理！')
              self.setVisible('01')
            } else {
              self.$alert(self.responseObj.状态 + ',' + self.responseObj.说明)
              self.setVisible('03')
              // self.getPhoto()
            }
            self.payButtonDisable = true
          } else {
            // self.getPhoto()
            self.feeList = response.data.responseObj.欠费金额

            let total = 0
            self.feeList.forEach(function (e) {
              total = total + Number(e.AMOUNT)
            })
            self.viewForm.总额 = total
            self.loadCurrentPage()
            // 初始化form的属性值
            self.form.feeAmount = self.Ginkgo.format(total, 'number')
            self.form.payableAmount = self.Ginkgo.format(total, 'number')

            self.form.field1 = self.responseObj.姓名
            self.form.field2 = vssfl // 宿舍分类序号。已有缴费记录，已有住宿标准的的学生传入-1
            self.form.field3 = self.responseObj.性别
            self.form.field4 = self.responseObj.年级
            self.form.field5 = self.responseObj.班级
            self.form.field6 = self.dormMoney // 宿舍收费标准

            console.log('获取机构')
            self.getDeptSet()
          }
        } else {
          self.buttonLoad = false
          self.$alert(response.data.result.msg)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    chooseDorm: function () {
      console.log('selectedRadio', this.selectedRadio === '')
      if (process.env.NODE_ENV === 'production') {
        if (this.selectedRadio === '') {
          this.$alert('请选择宿舍！')
        } else {
          let obj = this.dormList.filter(item => item.分类名称 === this.selectedRadio)[0]
          this.dormMoney = obj.分类标准
          this.queryInfo(obj.分类序号)
        }
        // if (this.multipleSelectionDorm.length === 0) {
        //   this.$alert('请选择宿舍！')
        // } else {
        //   if (this.multipleSelectionDorm.length > 1) {
        //     this.$alert('只能选择一个宿舍！')
        //   } else {
        //     console.log('选择了宿舍！！')
        //     this.queryInfo(this.multipleSelectionDorm[0].分类序号)
        //   }
        // }
      } else {
        if (this.selectedRadio === '') {
          this.$alert('请选择宿舍！')
        } else {
          this.viewForm = {
            注册号: 'xxxxxx',
            姓名: '张三',
            性别: '男',
            年级: 'nj',
            班级: 'bj',
            总额: 10000
          }
          this.feeData = [
            {ITEM: '保险费', AMOUNT: 90.00},
            {ITEM: '体检费', AMOUNT: 80.00},
            {ITEM: '其它', AMOUNT: 70.00},
            {ITEM: '饭卡费', AMOUNT: 80.00},
            {ITEM: '服装费', AMOUNT: 50.00}
          ]
          this.setVisible('03')
        }
      }
    },
    // 获取机构支付配置
    getDeptSet: function () {
      var self = this
      self.axios.get('/public/getBaseDeptSetByDeptID', { params: {
        deptId: self.global.deptId
      }})
      .then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          self.setVisiblePayButton(response.data.viDeptSetList)
          self.setVisible('03')
        }
        self.buttonLoad = false
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 生成订单
    createOrderInfo: function () {
      var self = this
      // 增加一条账单账单
      this.form.id = 0
      this.form.transDt = 0
      this.form.term = this.Ginkgo.getTimeStamp() // 处理账期
      this.form.statusCode = '02' // 初始核准状态
      this.form.deptId = this.global.deptId
      this.form.keyInfo = this.responseObj.注册号
      this.form.feeNo = '总额'
      this.form.idIf = 2
      // console.log('self.form', self.form)
      console.log('form....', this.form)
      this.axios.get('/iif/addOrderInfo', { params: this.form }
      )
      .then(function (response) {
        if (response.data.result.success === true) {
          // 处理账期列表，用于下面的doPay接口
          self.termList = []
          self.termList.push(self.form.term)
          self.unionPay()
          self.buttonLoad = false
        } else {
          self.buttonLoad = false
          self.$alert('生成账单失败！')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    toPay: function () {
      this.form.feeAmount = this.form.feeAmount || 0
      if (this.Ginkgo.isNumber(this.form.feeAmount) && this.form.feeAmount > 0) {
        this.checkPayTime()
      } else {
        this.$alert('金额必须输入数字！')
      }
    },
    checkPayTime: function () {
      var self = this
      self.buttonLoad = true
      self.axios.get('/pay/checkToPay', { params: {
        deptId: self.global.deptId // 1000003
      }})
      .then(function (response) {
        if (response.data.return_msg === 'SUCCESS') {
          self.createOrderInfo() // 成功生成订单
          self.buttonLoad = false
        } else {
          self.buttonLoad = false
          self.$alert(response.data.prop)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    setVisiblePayButton: function (deptSetList) {
      var self = this
      self.feePayType_UN = false
      self.feePayType_WX = false
      // 机构配置信息
      if (deptSetList.length > 0) {
        self.payRule = deptSetList[0].payRule
        if (self.payRule === '03') {
          self.isAllTermPay = true
        } else {
          self.isAllTermPay = false
        }
        deptSetList.forEach(function (e) {
          if (e.payType === '01' || e.payType === '14') {
            self.payTypeUnion = e.payType
            self.feePayType_UN = true
          } else if (e.payType === '02' || e.payType === '03' || e.payType === '99') {
            self.payType = e.payType
            self.feePayType_WX = true
          }
        })
      }
    },
    back: function (type) {
      this.setVisible('01')
    },
    unionPay: function () {
      var self = this
      console.log('银联支付')
      self.axios.post('/pay/toPay', {
        keyInfo: self.global.curUser.keyInfo,
        deptId: self.global.deptId,
        payType: self.payTypeUnion,
        feeTermList: self.termList,
        channelType: '02',
        validType: '01'
      })
      .then(function (response) {
        self.buttonLoad = false
        var wechatUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + self.payTypeUnion + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02'
        window.location.href = wechatUrl
      })
      .catch(function (error) {
        self.buttonLoad = false
        console.log(error)
      })
    },
    loadCurrentPage: function () {
      this.feeData = this.feeList
    },
    // 列数据格式化
    dataFormat: function (row, column, cellValue) {
      return this.Ginkgo.format(row.分类标准, 'money')
    },
    // 获取历史缴费信息
    getHistory: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.axios.get('/iif/getOrderInfoForHistory', { params: {
          deptId: self.global.deptId,
          keyInfo: self.global.curUser.keyInfo
        }})
        .then(function (response) {
          // 机构配置信息
          if (response.data.result.success === true) {
            self.orderInfoList = response.data.orderInfoList
            // 首次默认排序
            self.handleSortChangeHistory(self.sort)
            // 分页处理
            self.page.totalElements = self.orderInfoList.length
            self.loadCurrentPageHistory()
            // 设置当前选中行
            self.setCurrentRowHistory()
            self.setVisible('04')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.orderInfoList = [
          {transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx'}
        ]
        this.setVisible('05')
      }
    },
    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function (val) {
      this.sort = val
      let sorts = this.Ginkgo.cloneObj(this.sortSet)
      sorts.pop() // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val)
      this.orderInfoList = this.Ginkgo.sort(this.orderInfoList, sorts)
      this.loadCurrentPage()
    },
    // 选中当前行
    setCurrentRowHistory: function () {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex])
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function () {
      this.tableData = this.orderInfoList.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size)
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function (val) {
      this.page.size = val
      this.loadCurrentPageHistory()
    },
    // 页码改变事件
    handleCurrentChangeHistory: function (val) {
      this.page.number = val - 1
      this.loadCurrentPageHistory()
    },
    // 获取查询结果配置
    getUISetQueryResult: function (form) {
      let setId = form === '01' ? 'tbIf_Order_Info_MyBillSiYuan' : 'tbExp_Student_Item'
      let sort = {prop: 'sortNoResult', order: 'ascending'}

      let list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1'
      })

      return this.Ginkgo.sortList(list, sort)
    },
    // 获取查询结果配置
    getUISetCommon: function (form) {
      let setId = form === '01' ? 'tbIf_Order_Info_MyBillSiYuan' : 'tbExp_Student_Item'

      let listUi = this.uiSetList.filter(function (element) {
        return element.uiSetId === setId
      })

      return listUi[0]
    },
    // 列数据格式化
    dataFormatHistory: function (row, column, cellValue) {
      var columnProp = column.property
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp
      })[0].formatString

      return this.Ginkgo.format(cellValue, formatString)
    },
    // 获取同组记录
    getHeaderGroup: function (item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form))
    },
    // 列可见性
    getHeaderVisible: function (item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed)
    },
    // 操作列可见性
    getOpVisible: function (form) {
      return this.Ginkgo.getOpVisible(this.getUISetQueryResult(form))
    },
    handleSelect: function (index, indexPath) {
      if (process.env.NODE_ENV === 'production') {
        if (index === '/MyBill') {
          this.login()
        } else {
          this.getHistory()
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('01')
        } else {
          this.setVisible('01')
        }
      }
    },
    showWechatImg: function () {
      this.dialogFormVisible = true
    },
    handleButtonCommand: function (url) {
      window.location.href = url
    }
  }
}
</script>

<style>
.top1{width:auto; height:25px; background:#F4F4F4; padding-top:5px;}
.top_1{width:965px; height:17px; margin:0px auto; font-size:12px; padding-left:15px;}
.top_1_1{width:490px; float:left}
.top_1_1 a{ color:#666; text-decoration:none; }
.top_1_1 a:hover{ color:#000; text-decoration:underline }

.top_1_2 {width:330px; height:auto; float:right; margin-right:10px;}
/************下拉开始*************/
#sddm
{	margin: 0 auto;
	padding: 0;
	z-index: 30;
	width:330px;
	height:auto;}

#sddm li
{	margin:0px;
	padding:0 12px;
	list-style: none;
	float: left;
	width:auto;
}

#sddm li a
{	display: block;
	width:auto;
	color:#666;
	text-align: center;
	text-decoration: none}

#sddm li a:hover
{	 color:#000; text-decoration:underline}

#sddm div
{	position: absolute;
	visibility: hidden;
	margin: 0;
	padding: 0;
	background: #EAEBD8;
	border: 1px solid #5970B2}

	#sddm div a
	{	position: relative;
		display: block;
		margin: 0;
		padding: 5px 10px;
		width: auto;
		white-space: nowrap;
		text-align: left;
		text-decoration: none;
		background: #EAEBD8;
		color: #2875DE;
		font: 12px arial}

	#sddm div a:hover
	{	background: #49A3FF;
    color: #FFF
  }
  .top2{width:auto; height:72px;}
  .top2_1{width:980px;  height:auto; margin:0px auto}
  .logo{width:136px; height:38px; float:left; margin-top:17px;}
	.nav{width:445px; height:auto; float:right; margin-top:25px;}
  .nav ul{ margin:0px; padding:0px;}
  .nav ul li{ width:auto; height:auto; list-style-type:none; float:left; margin:0px 22px; text-align:center;}
  .nav a{ font-size:16px; color:#003399; text-decoration:none; font-weight:bold}
  .nav a:hover{font-size:16px; color:#000; text-decoration:underline; font-weight:normal}


  /************banner开始****************/
  .bannerbox{width:auto; height:385px;}


  /************banner结束****************/

  /*************第二部分开始*****************/

  .box2{width:998px; height:258px; margin:25px auto;}
  .jfbox{width:700px; height:125px; float:left;}
  .jfbox ul{margin:0px; padding:0px;}
  .jfbox ul li{width:96px; height:125px; float:left; text-align:center; margin-left:22px;}
  .jfbox ul li img{width:96px; height:90px; border:none;}
  .jfbox ul li a{ color:#003399; font-size:14px; text-decoration:none; font-weight:bold}
  .jfbox ul li a:hover{ color:#333}

  .xwdt{width:260px; height:100px; float:left; border-left:1px solid #CCC; padding-left:20px}
  .menub1_1{ font-size:14px; font-weight:bold; width:46px; text-align:center;}
  .menub1_1 a{color:#F00; text-decoration:none;}
  .menub1_1 a:hover{color:#666; text-decoration:none;}
  .menub1_2{ font-size:14px; font-weight:bold; width:46px; text-align:center;}
  .menub1_2 a{color:#F00; text-decoration:none}
  .menub1_2 a:hover{color:#666; text-decoration:none;}
  .menub1_3{ font-size:14px; font-weight:bold; width:46px; text-align:center}
  .menub1_3 a{color:#F00; text-decoration:none}
  .menub1_3 a:hover{color:#666; text-decoration:none;}

  .menugtab ul{ margin:0px; padding:0px;}
  .menugtab span{ margin:0px; padding:0px;float:right; width:auto; padding-right:10px;}
  .menugtab ul li{ width:268px; height:auto; font-size:12px;color:#666; margin-top:7px}
  .menugtab ul li a{ font-size:12px; color:#333; text-decoration:none}
  .menugtab ul li a:hover{ font-size:12px; color:#666; text-decoration:none}
  .cl1{ clear:both; width:auto; height:10px; border-bottom:1px solid #CCC; margin-bottom:5px}
  .content{ margin-top:15px;}

  /* .content .login{ background:url(../images/login_head.png) top left no-repeat; width:212px; float:right; padding-top:37px;} */
  .content .login div{ border:1px solid #EAEAEA; border-top:none; width:208px; height:175px;margin-left:1px; padding:15px 0;}
  .content .login .txt{ width:125px; border:1px solid #D0D0D0; height:25px;}


  .content .login table{ width:200px; height:170px; margin-left:10px;}
  .content .banner{ float:left; width:520px; height:239px; border:1px solid #CCCBCB; padding:1px; margin-left:10px;}
  .content .banner img{ width:520px; height:239px;}

  .content .tzgg{ width:236px; height:238px; float:left; padding-top:7px; padding-left:6px;border:1px solid #D4D4D2;}
  .content .tzgg .top_one{height:100px; padding-right:5px;}
  .content .tzgg .top_one img{ width:109px; height:86px; border:1px solid #D4D4D2; padding:1px; margin-right:5px; float:left;}
  .content .tzgg .top_one .title{ color:#FF0000; line-height:27px;}
  .content .tzgg .top_one .detail{ color:#FF0000; }

  .content .tzgg .list { margin-top:10px; margin-left:5px;}
  .content .tzgg .list li{ padding-left:0px;  line-height:25px; height:25px;}
  .content .tzgg .list li img{ margin-bottom:3px; margin: 2px,2px,2px,2px;}

  .content .program{ margin-top:15px;}
  .content .program a{ display:block; width:143px; height:132px; float:left; border:1px solid #DDDDDD; margin-right:25px;}
  .content .program img{ width:143px; height:132px; }

  .content .other{ margin-top:15px;}
  .content .other a{ display:block; width:303px; height:107px; float:left; border:1px solid #DDDDDD; margin-right:18px; background:#F9F9F9; padding:8px;}

  .footer{ height:120px; margin-top:15px; text-align:center;}
  .footer .copyright{ margin:10px auto; font-size:14px;}
  .footer .bs a{ margin:0 5px;}


  /*登陆页*/

  .content .h2{ text-align:center; color:#003B93; font-weight:600; font-size:25px; margin-top:40px; margin-bottom:35px;}

  .content .jf{ height:330px; border:1px solid #E9E9E9; padding:1px;}

  .content .jf .dlck{ width:350px; height:280px; border:1px solid #CECECE; background:#F4F4F4; margin-top:8px; margin-left:8px; padding:15px; font-size:14px; font-weight:400; line-height:30px;}
  .content .jf .dlck .h3{text-align:center; color:#FF0000; font-weight:600; font-size:20px; padding-top:20px;}

  .content .jf .dlck .ts{ height:55px; border-bottom:1px dashed #666666; text-align:center; margin-top:15px;}
  .content .jf .dlck p{ text-align:center;}

  .content .jf .dlck dl{ margin-top:20px;}
  .content .jf .dlck .dd{ width:345px; height:30px; margin-bottom:18px;}
  /* .Copy{width:510px; height:50px; margin:0px auto; font-size:12px; color:#999; text-align:center; line-height:200%; margin-top:120px;} */
  /*********通用bottom************/
  .tybottom{width:auto; height:236px; margin-top:10px}
  .hzhb{width:950px; height:82px; margin:0px auto;}
  .hzhb h2{font-size:14px; color:#7F7F7F; padding-top:20px;}
  .hzhb ul{margin:0px; padding:0px;}
  .hzhb ul li{width:20px; height:20px; float:left; margin:5px 9px}
  .main{ width:1000px;margin:0 auto;}
  .form-item {
    height: 40px;
    line-height: 40px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: #fff;
    /* margin-bottom: 2px; */
    margin-left: 5px;
  }
  .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: #fff;
    margin-left: 5px;
  }
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
  .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
    line-height: 40px !important;
  }
  .label_detail {
    margin: 0px 0px 0px 20px;
  }
  .label_value {
    margin: 0px 30px 0px 0px;
    float: right;
    /* width: 40% */
  }
  /* .el-radio__label {
    font-size: 12px !important;
    padding-left: 10px;
  } */
</style>


// WEBPACK FOOTER //
// MyBillSiYuan.vue?71a5cb94